(() => {
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const recoverPlayback = (section) => {
    const desktopVideo = section.querySelector('[data-novel-hero-media="desktop"]');
    const mobileVideo = section.querySelector('[data-novel-hero-media="mobile"]');
    const activeVideo = mobileQuery.matches ? mobileVideo : desktopVideo;
    const inactiveVideo = mobileQuery.matches ? desktopVideo : mobileVideo;

    inactiveVideo?.pause();

    if (!activeVideo) return;

    activeVideo.muted = true;
    activeVideo.defaultMuted = true;
    activeVideo.playsInline = true;

    const playback = activeVideo.play();

    if (playback && typeof playback.catch === 'function') {
      playback.catch(() => {
        activeVideo.addEventListener(
          'canplay',
          () => {
            activeVideo.play().catch(() => {});
          },
          { once: true }
        );
      });
    }
  };

  const recoverAll = () => {
    document.querySelectorAll('[data-novel-hero-video]').forEach(recoverPlayback);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recoverAll, { once: true });
  } else {
    recoverAll();
  }

  mobileQuery.addEventListener?.('change', recoverAll);
  window.addEventListener('pageshow', recoverAll);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) recoverAll();
  });
  document.addEventListener('shopify:section:load', recoverAll);
})();
